import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import debounce from "lodash.debounce";
import "./NoteEditor.css";
import { useTranslation } from "react-i18next"; // Importer useTranslation

const NoteEditor = (props) => {
  const { t } = useTranslation(); // Assigner useTranslation à {t}
  const [value, setValue] = useState("");
  const [noteBook, setNoteBook] = useState(null);

  // Ouvrir ou créer la note dès le rendu du composant
  useEffect(() => {
    const fetchNoteBook = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/notebook`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ lessonId: props.lessonId }),
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || t("notebook_download_error"));
        }

        setNoteBook(data.noteBook);
        setValue(data.noteBook.content);
      } catch (err) {
        console.error(err);
      }
    };
    fetchNoteBook();
  }, [props.lessonId, t]);

  // Fonction pour sauvegarder la note
  const saveNote = async (content) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/notebook`,
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ content, noteBookId: noteBook._id }),
        }
      );

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || t("notebook_save_error"));
      }
    } catch (err) {
      console.error(err);
    }
  };

  const debouncedSaveNote = debounce(saveNote, 1000);

  const handleChange = (content) => {
    setValue(content);
    debouncedSaveNote(content);
  };

  return (
    <>
      <h1 className="editor-title">{t("notebook_title")}</h1>
      <ReactQuill
        value={value}
        onChange={handleChange}
        modules={{
          toolbar: [
            [{ header: "1" }, { header: "2" }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["bold", "italic"],
            ["link"],
            ["clean"],
          ],
        }}
        className="note-editor"
      />
    </>
  );
};

export default NoteEditor;
